import { memo } from "react";
function PreDispatchIcon({ color = "#CF0000" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clip-path="url(#clip0_11766_9801)">
        <mask id="mask0_11766_9801" style={{ maskType: 'luminance' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
          <path d="M0 0H16V16H0V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_11766_9801)">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M2.66669 5.33317H4.66669V2.6665H9.33335V3.99984H6.00002V9.99984H10.52C10.8867 9.59317 11.4067 9.33317 12 9.33317C12.5934 9.33317 13.1134 9.59317 13.48 9.99984H14V5.99984H15.3334V11.3332H14C14 12.4398 13.1067 13.3332 12 13.3332C10.8934 13.3332 10 12.4398 10 11.3332H6.00002C6.00002 12.4398 5.10669 13.3332 4.00002 13.3332C2.89335 13.3332 2.00002 12.4398 2.00002 11.3332H0.666687V7.99984L2.66669 5.33317ZM1.69335 7.99984L3.00002 6.33317H4.66669V7.99984H1.69335ZM12.6667 11.3332C12.6667 11.6998 12.3667 11.9998 12 11.9998C11.6334 11.9998 11.3334 11.6998 11.3334 11.3332C11.3334 10.9665 11.6334 10.6665 12 10.6665C12.3667 10.6665 12.6667 10.9665 12.6667 11.3332ZM4.66669 11.3332C4.66669 11.6998 4.36669 11.9998 4.00002 11.9998C3.63335 11.9998 3.33335 11.6998 3.33335 11.3332C3.33335 10.9665 3.63335 10.6665 4.00002 10.6665C4.36669 10.6665 4.66669 10.9665 4.66669 11.3332Z" fill={color}/>
          <path d="M15.3334 3.33324L9.49335 9.21344L6.66669 6.38675L7.60669 5.44675L9.49335 7.33344L14.3934 2.3999L15.3334 3.33324Z" fill={color} />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_11766_9801">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default memo(PreDispatchIcon);